import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../services/api";
import { FaUser, FaEnvelope, FaLock, FaUserTag, FaUserPlus } from "react-icons/fa";

function Register() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        role: "viewer"
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.password) {
            alert("Please fill in all required fields.");
            return;
        }

        try {
            setLoading(true);
            await API.post("/auth/register", form);
            alert("Registration Successful!");
            navigate("/login");
        } catch (error) {
            alert(error.response?.data?.message || "Registration failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div 
            className="d-flex align-items-center justify-content-center min-vh-100 p-3" 
            style={{ 
                background: "radial-gradient(circle at 50% 50%, #1e1b4b 0%, #0f172a 100%)",
                position: "relative",
                overflow: "hidden"
            }}
        >
            {/* Background decorative glowing circles */}
            <div 
                style={{
                    position: "absolute",
                    width: "300px",
                    height: "300px",
                    background: "rgba(79, 70, 229, 0.15)",
                    borderRadius: "50%",
                    filter: "blur(80px)",
                    top: "10%",
                    left: "15%"
                }}
            />
            <div 
                style={{
                    position: "absolute",
                    width: "300px",
                    height: "300px",
                    background: "rgba(16, 185, 129, 0.1)",
                    borderRadius: "50%",
                    filter: "blur(80px)",
                    bottom: "10%",
                    right: "15%"
                }}
            />

            <div 
                className="w-100 animate-fade-in" 
                style={{ maxWidth: "450px", zIndex: 10 }}
            >
                <div 
                    className="card border-0 shadow-lg"
                    style={{
                        background: "rgba(30, 41, 59, 0.7)",
                        backdropFilter: "blur(16px)",
                        border: "1px solid rgba(255, 255, 255, 0.08) !important",
                        color: "#f8fafc",
                        padding: "2rem 1.5rem"
                    }}
                >
                    <div className="card-body p-0">
                        <div className="text-center mb-4">
                            <h2 className="fw-extrabold text-white mb-2">
                                Create Account
                            </h2>
                            <p style={{ color: "#94a3b8" }}>
                                Register a new account to join the agency
                            </p>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {/* Name */}
                            <div className="mb-3">
                                <label className="form-label small fw-semibold text-uppercase" style={{ letterSpacing: "0.5px", color: "#cbd5e1" }}>
                                    Full Name
                                </label>
                                <div className="input-group">
                                    <span 
                                        className="input-group-text border-0" 
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)", 
                                            color: "#94a3b8",
                                            borderRadius: "10px 0 0 10px"
                                        }}
                                    >
                                        <FaUser />
                                    </span>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="John Doe"
                                        className="form-control text-white border-0"
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)",
                                            borderRadius: "0 10px 10px 0"
                                        }}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Email */}
                            <div className="mb-3">
                                <label className="form-label small fw-semibold text-uppercase" style={{ letterSpacing: "0.5px", color: "#cbd5e1" }}>
                                    Email Address
                                </label>
                                <div className="input-group">
                                    <span 
                                        className="input-group-text border-0" 
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)", 
                                            color: "#94a3b8",
                                            borderRadius: "10px 0 0 10px"
                                        }}
                                    >
                                        <FaEnvelope />
                                    </span>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="john@agency.com"
                                        className="form-control text-white border-0"
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)",
                                            borderRadius: "0 10px 10px 0"
                                        }}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Password */}
                            <div className="mb-3">
                                <label className="form-label small fw-semibold text-uppercase" style={{ letterSpacing: "0.5px", color: "#cbd5e1" }}>
                                    Password
                                </label>
                                <div className="input-group">
                                    <span 
                                        className="input-group-text border-0" 
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)", 
                                            color: "#94a3b8",
                                            borderRadius: "10px 0 0 10px"
                                        }}
                                    >
                                        <FaLock />
                                    </span>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="••••••••"
                                        className="form-control text-white border-0"
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)",
                                            borderRadius: "0 10px 10px 0"
                                        }}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Role Select */}
                            <div className="mb-4">
                                <label className="form-label small fw-semibold text-uppercase" style={{ letterSpacing: "0.5px", color: "#cbd5e1" }}>
                                    Access Role
                                </label>
                                <div className="input-group">
                                    <span 
                                        className="input-group-text border-0" 
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)", 
                                            color: "#94a3b8",
                                            borderRadius: "10px 0 0 10px"
                                        }}
                                    >
                                        <FaUserTag />
                                    </span>
                                    <select
                                        name="role"
                                        className="form-select text-white border-0"
                                        style={{ 
                                            background: "rgba(15, 23, 42, 0.5)",
                                            borderRadius: "0 10px 10px 0",
                                            cursor: "pointer"
                                        }}
                                        value={form.role}
                                        onChange={handleChange}
                                    >
                                        <option value="viewer" style={{ background: "#1e293b", color: "#fff" }}>Viewer (Read Only)</option>
                                        <option value="manager" style={{ background: "#1e293b", color: "#fff" }}>Manager (Create & Edit)</option>
                                        <option value="admin" style={{ background: "#1e293b", color: "#fff" }}>Admin (Full Access)</option>
                                    </select>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 py-3 mt-2"
                                style={{
                                    boxShadow: "0 4px 14px rgba(79, 70, 229, 0.4)",
                                    fontSize: "1rem"
                                }}
                                disabled={loading}
                            >
                                {loading ? (
                                    "Registering..."
                                ) : (
                                    <>
                                        <FaUserPlus /> Register
                                    </>
                                )}
                            </button>
                        </form>

                        <div className="text-center mt-4 pt-2">
                            <p className="mb-0 text-muted small">
                                Already have an account?{" "}
                                <Link 
                                    to="/login" 
                                    className="text-primary text-decoration-none fw-bold"
                                    style={{ color: "#818cf8 !important" }}
                                >
                                    Login Here
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Register;